import { jsxs as M, jsx as h } from "react/jsx-runtime";
const l = (v) => /* @__PURE__ */ M(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 64 64",
    ...v,
    children: [
      /* @__PURE__ */ h(
        "path",
        {
          fill: "currentColor",
          d: "M49.934 52.978V6.275H14.221l.013 48.803a3.025 3.025 0 0 0 3.026 3.025h12.032V49.73h5.416v8.372h12.297l-1.072-4h-7.225V45.73H25.292v8.372h-7.058l-.012-43.828h27.712V54.05l4-1.072Z"
        }
      ),
      /* @__PURE__ */ h(
        "path",
        {
          fill: "currentColor",
          d: "M23.691 38.822h-2.877v2.877h2.877v-2.877ZM30.185 38.822h-2.877v2.877h2.877v-2.877ZM36.68 38.822h-2.878v2.877h2.877v-2.877ZM43.174 38.822h-2.878v2.877h2.878v-2.877ZM23.691 32.328h-2.877v2.877h2.877v-2.877ZM30.185 32.328h-2.877v2.877h2.877v-2.877ZM36.68 32.328h-2.878v2.877h2.877v-2.877ZM43.174 32.328h-2.878v2.877h2.878v-2.877ZM23.691 25.834h-2.877v2.877h2.877v-2.877ZM30.185 25.834h-2.877v2.877h2.877v-2.877ZM36.68 25.834h-2.878v2.877h2.877v-2.877ZM43.174 25.834h-2.878v2.877h2.878v-2.877ZM23.691 19.34h-2.877v2.877h2.877V19.34ZM30.185 19.34h-2.877v2.877h2.877V19.34ZM36.68 19.34h-2.878v2.877h2.877V19.34ZM43.174 19.34h-2.878v2.877h2.878V19.34ZM23.691 12.846h-2.877v2.877h2.877v-2.877ZM30.185 12.846h-2.877v2.877h2.877v-2.877ZM36.68 12.846h-2.878v2.877h2.877v-2.877ZM43.174 12.846h-2.878v2.877h2.878v-2.877Z"
        }
      )
    ]
  }
);
export {
  l as Flats
};
